import React, { memo } from 'react'
import projectCommentConnector from 'root/src/client/logic/comment/connectors/projectCommentConnector'
import withModuleContext from 'root/src/client/util/withModuleContext'

// eslint-disable-next-line import/no-cycle
import Comment from './Comment'

const CommentConnected = props => <Comment {...props} />

export default withModuleContext(projectCommentConnector(memo(CommentConnected)))
